module.exports = __webpack_public_path__ + "element-icons.ttf?732389d";


//////////////////
// WEBPACK FOOTER
// ./~/element-ui/lib/theme-chalk/fonts/element-icons.ttf
// module id = 448
// module chunks = 9